import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatientForSendai } from 'sections/sendai/features/useIncidentDetailForSendai';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';
import { DataNotFound } from 'core/components/common/DataNotFound';
import { FC } from 'react';

type Props = {
  treatments: IncidentDetailPatientForSendai['treatments'];
};

export const TreatmentView: FC<Props> = ({ treatments }) => {
  if (!treatments || treatments.length === 0) {
    return (
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="応急処置" />
          <DataNotFound />
        </div>
      </BorderedContainer>
    );
  }

  // sendaiでは最初のtreatmentのみ表示
  const treatment = treatments[0];

  // generalTreatmentsとexecuteTreatmentを統合
  const allTreatments = [
    ...(treatment?.data?.generalTreatments ?? []),
    ...(treatment?.data?.executeTreatment ?? []),
  ];

  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="応急処置" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="救急救命処置選択（応急措置含む）"
            content={<TagList tags={allTreatments} />}
          />
        </div>
      </div>
    </BorderedContainer>
  );
};
